import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  toggle() {
    this.panelTargets.forEach((element) => {
      element.classList.toggle(this.#className(element))
    })
  }

  hide() {
    this.panelTargets.forEach((element) => {
      element.classList.add(this.#className(element))
    })
  }

  #className(element) {
    return element.dataset.toggleClass || "hidden"
  }
}
